export function changeCursorOnHovertest(map, layer) {
  map.on("mouseenter", layer, function () {
    map.getCanvas().style.cursor = "pointer";
  });
  map.on("mouseleave", layer, function () {
    map.getCanvas().style.cursor = "";
  });
}

export async function getPropertiesInView(featuresInMap, maplibreMap) {
  let all_properties_in_current_view = [];

  for (let i = 0; i < featuresInMap.length; i++) {
    const feature = featuresInMap[i];

    if (feature.properties.cluster) {
      const single_property_in_cluster = await _getPropertyInCluster(
        feature.properties.cluster_id,
        feature.properties.point_count,
        0,
        maplibreMap
      );
      all_properties_in_current_view.push(single_property_in_cluster);
    }

    if (!feature.properties.cluster) {
      all_properties_in_current_view.push(feature);
    }
  }

  return all_properties_in_current_view.flat();
}

function _getPropertyInCluster(cluster_id, limit, offset, maplibreMap) {
  return new Promise((resolve, reject) => {
    maplibreMap
      .getSource("properties-cluster-source")
      .getClusterLeaves(cluster_id, limit, offset, (err, features) => {
        if (err) reject(err);
        else resolve(features);
      });
  });
}
